import { useEffect, useRef } from 'react';

export function usePreviousColumnDefs(columnDefs = [], isRequestingRows) {
  const prevColDefsRef = useRef([]);

  useEffect(() => {
    if (isRequestingRows) return;
    prevColDefsRef.current = columnDefs;
  }, [columnDefs, isRequestingRows]);

  return prevColDefsRef.current;
}
